<div class="content-col">
  <nz-card nzBordered class="content-col">
    <nz-card-meta [nzAvatar]="avatarTemplate"></nz-card-meta>
    <ng-template #avatarTemplate>
      <div class="post-thumb"><img (click)="onClick()" [src]="image" />
        <div *ngFor="let file of files" class="pgbar">
          <nz-progress [nzPercent]="file.progress" [nzStrokeColor]="'#1890ff'"></nz-progress>
        </div>
      </div>
    </ng-template>
    
    <nz-spin [nzSpinning]="isLoading" class="content-col">
      <div class="content"> 
        <mat-divider> </mat-divider>
        <div class="sideRight">
          <form [formGroup]="formGroup" nz-form>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label nzFor="iduser">{{'systemView.idUser' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <input nz-input id="iduser" formControlName="iduser" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label nzFor="username">{{'systemView.username' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <input nz-input id="username" formControlName="username" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24">
                <nz-form-item>
                  <nz-form-label nzFor="nome">{{'systemView.name' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <input nz-input id="nome" formControlName="nome" #nome />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label nzFor="usetab">{{'systemView.useTabs' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <nz-select id="usetab" formControlName="usetab" nzPlaceHolder="Selecione">
                      <nz-option *ngFor="let item of simnao" [nzValue]="item.key" [nzLabel]="item.value"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label nzFor="layout">{{'systemView.layout' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <nz-select id="layout" formControlName="layout" nzPlaceHolder="Selecione">
                      <nz-option *ngFor="let tipo of layoutOption" [nzValue]="tipo.key" [nzLabel]="tipo.value"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label nzFor="timeout">{{'systemView.timeout' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <input nz-input id="timeout" type="number" formControlName="timeout" #timeout />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label nzFor="iddashboard">{{'systemView.dashboard' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <!---input nz-input id="iddashboard" type="number" formControlName="iddashboard" #iddashboard /-->
                    <search-input-new formControlName="iddashboard" [searchProperties]="searchDashboard"></search-input-new>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </form>
          <div class="sideLeftPassWord">
            <form [formGroup]="senhaGroup" nz-form class="password-form" [nzLayout]="'vertical'">
              <nz-form-item>
                <nz-form-label nzFor="oldPassword">{{'systemView.currentPassword' | translateTA}}</nz-form-label>
                <nz-form-control>
                  <nz-input-group [nzSuffix]="suffixTemplate">
                    <input nz-input id="oldPassword" placeholder="Senha" formControlName="oldPassword" [type]="hide ? 'password' : 'text'" />
                  </nz-input-group>
                  <ng-template #suffixTemplate>
                    <i nz-icon [nzType]="hide ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="hide = !hide" style="cursor: pointer;"></i>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>

              <div class="password-new-confirmation">
                <nz-form-item class="fields">
                  <nz-form-label nzFor="password">{{'systemView.newPassword' | translateTA}}</nz-form-label>
                  <nz-form-control>
                    <nz-input-group [nzSuffix]="suffixPasswordTemplate">
                      <input nz-input id="password" placeholder="Senha" formControlName="password" [type]="hide ? 'password' : 'text'" />
                    </nz-input-group>
                    <ng-template #suffixPasswordTemplate>
                      <i nz-icon [nzType]="hide ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="hide = !hide" style="cursor: pointer;"></i>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item class="fields">
                  <nz-form-label nzFor="confirmacao">{{'systemView.confirmPassword' | translateTA}}</nz-form-label>
                  <nz-form-control [nzErrorTip]="confirmacao.touched && confirmacao.errors?.senhasNaoCoincidem ?( 'systemView.passwordMismatch' | translateTA ): ''">
                    <nz-input-group [nzSuffix]="suffixConfirmaTemplate">
                      <input nz-input id="confirmacao" placeholder="{{'systemView.confirmPassword' | translateTA}}" formControlName="confirmacao" [type]="hideConfirmacao ? 'password' : 'text'" />
                    </nz-input-group>
                    <ng-template #suffixConfirmaTemplate>
                      <i nz-icon [nzType]="hideConfirmacao ? 'eye-invisible' : 'eye'" nzTheme="outline" (click)="hideConfirmacao = !hideConfirmacao" style="cursor: pointer;"></i>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            
              <label class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('minlength')  ? 'text-danger' : 'text-success'"
                  >
                    <i nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('minlength') ? 'close-circle' : 'check-circle'" nzTheme="outline"></i>
                    {{'systemView.minLength' | translateTA:{tam:passwordMinLength} }}
                  </label>
                
                  <label
                    class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasNumber')  ? 'text-danger' : 'text-success'"
                  >
                    <i nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasNumber') ? 'close-circle' : 'check-circle'" nzTheme="outline"></i>
                    {{'systemView.hasNumber' | translateTA}}
                  </label>

                  <label
                    class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'"
                  >
                    <i nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasCapitalCase') ? 'close-circle' : 'check-circle'" nzTheme="outline"></i>
                    {{'systemView.hasCapitalCase' | translateTA}}
                  </label>

                  <label
                    class="col"
                    [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'"
                  >
                    <i nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSmallCase') ? 'close-circle' : 'check-circle'" nzTheme="outline"></i>
                    {{'systemView.hasSmallCase' | translateTA}}
                  </label>

                  <label
                  class="col"
                  [ngClass]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSpecialCharacter')  ? 'text-danger' : 'text-success'"
                  >
                  <i nz-icon [nzType]="senhaGroup.controls['password'].hasError('required') || senhaGroup.controls['password'].hasError('hasSpecialCharacter') ? 'close-circle' : 'check-circle'" nzTheme="outline"></i>
                  {{'systemView.hasSpecialCharacter' | translateTA}}
                  </label>
            </form>
          </div>

          
        </div>
        <div class="nz-card-actions" style="padding: 16px; text-align: right; border-top: 1px solid #f0f0f0;">
          <button nz-button nzType="primary" (click)="salvar()">
            {{'systemView.save' | translateTA}}
          </button>
        </div>
      </div>
    </nz-spin>
  </nz-card>
</div>

<input type="file" #fileInput id="fileUpload" name="fileUpload" accept="image/*" class="hide" (change)="showPreview($event)" />
